module.exports = __webpack_public_path__ + "static/media/a6.d9f2238b.jpg";